import Vue from 'vue'
import App from '@/App'
import router from '@/router'                 // api: https://github.com/vuejs/vue-router
import store from '@/store'                   // api: https://github.com/vuejs/vuex
import VueCookie from 'vue-cookie'            // api: https://github.com/alfhen/vue-cookie
import httpRequest from '@/utils/httpRequest' // api: https://github.com/axios/axios
import { parseToDate,getMonth,getYear,addMonth,getFullMonth } from '@/utils'
import { isAuth } from '@/utils/login'
import cloneDeep from 'lodash/cloneDeep'
import 'babel-polyfill'
import ElementUI from 'element-ui';
import '@/element-ui'                         // api: https://github.com/ElemeFE/element
import '@/icons'                              // api: http://www.iconfont.cn/
import '@/element-ui-theme'
import '@/assets/scss/index.scss'
import 'element-ui/lib/theme-chalk/index.css'
// import 'element-ui/lib/theme-chalk/index.css'
import "babel-polyfill"
import './directives/index'
import VueQuillEditor from 'vue-quill-editor'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
// import Viser from 'viser-vue'
import echarts from 'echarts'
Vue.prototype.$echarts = echarts
// Vue.use(Viser)
Vue.use(VueCookie)
Vue.use(ElementUI)
Vue.use(VueQuillEditor)
Vue.config.productionTip = false
// 非生产环境, 适配mockjs模拟数据                 // api: https://github.com/nuysoft/Mock
if (process.env.NODE_ENV !== 'production') {
  require('@/mock')
}
//附件上传组件
import docUploadForm from './components/docUploadForm/index'//表单页
import docUploadView from './components/docUploadView/index'//详情页
import imgUpload from './components/imgUpload/index'//图片上传+OCR识别表单
import imgUploadView from './components/imgUploadView/index'//图片上传+OCR识别详情
import stepCom from './components/stepCom/index' //步骤条
//全局loading
import loadingTel from './components/loading/index'
//企业资质新增
import qualificationAdd from './components/qualificationCertificateAdd/index'

Vue.component("docUploadForm", docUploadForm);
Vue.component("docUploadView", docUploadView);
Vue.component("imgUpload", imgUpload);
Vue.component("imgUploadView", imgUploadView);
Vue.component("qualificationAdd", qualificationAdd);
Vue.component("loadingTel", loadingTel);
Vue.component("stepCom", stepCom);
// 挂载全局
Vue.prototype.$http = httpRequest // ajax请求方法
Vue.prototype.isAuth = isAuth     // 权限方法
Vue.prototype.parseToDate = parseToDate
Vue.prototype.getMonth = getMonth
Vue.prototype.getYear = getYear
Vue.prototype.addMonth = addMonth
Vue.prototype.getFullMonth = getFullMonth

// 保存整站vuex本地储存初始状态
window.SITE_CONFIG['storeState'] = cloneDeep(store.state)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App)
})
